module.exports = __webpack_public_path__ + "img/teamImg26.29f2eb9e.jpg";